import { Injectable } from '@angular/core';

@Injectable()
export class RcDeviceService {

    public windowWidth;
    public windowHeight;
    private currentOverflowY: any;
    protected xs:number = 576;
    protected sm:number = 768;
    protected md:number = 992;
    protected lg:number = 1200;

    constructor() {
        window.addEventListener('scroll', () => {
            this.windowWidth = window.innerWidth;
        });
        window.addEventListener('resize', () => {
            this.setWindowDimensions()
        });
        this.setWindowDimensions()
    }

    setWindowDimensions() {
        try {
            this.windowWidth = window.innerWidth;
            this.windowHeight = document.documentElement.clientHeight;
        } catch (e) {
        }
    }

    disableScrolling() {
        try {
            this.currentOverflowY = document.body.style.overflowY;
            document.body.style.overflowY = 'hidden';
        } catch (e) {
            console.log(e);
        }
    }

    enableScrolling() {
        try {
            document.body.style.overflowY = this.currentOverflowY;
        } catch (e) {
            console.log(e);
        }
    }

    /**
     *  Check screen resolution (windowWidth < 576px)
     */
    isXs() {
        return this.windowWidth < this.xs;
    }

    /**
     *  Check screen resolution (windowWidth >= 576px && windowWidth < 768px)
     */
    isSm() {
        return this.windowWidth >= this.xs && this.windowWidth < this.sm;
    }

    /**
     *  Check screen resolution (windowWidth >= 768px && windowWidth < 992px)
     */
    isMd() {
        return this.windowWidth >= this.sm && this.windowWidth < this.md;
    }

    /**
     *  Check screen resolution (windowWidth >= 992px && windowWidth < 1200px)
     */
    isLg() {
        return this.windowWidth >= this.md && this.windowWidth < this.lg;
    }

    /**
     *  Check screen resolution (windowWidth >= 1200px)
     */
    isXl() {
        return this.windowWidth >= this.lg;
    }

    /**
     * Check if the user agent is IE
     */
    isIE() {
        const ua = navigator.userAgent.toLowerCase();

        return ua.indexOf('msie') > -1 || ua.indexOf('trident/') > -1 || ua.indexOf('edge/') > -1;
    }

    /**
     * Check if the user agent is Safari
     */
    public isSafari(): boolean {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1) {
            if (ua.indexOf('crios') > -1) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    }

    /**
     * Check if the user agent is Mobile Device
     */
    isMobileDeviceByUserAgent() {
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
    }

    /**
     * Check if the user agent is iOS
     */
    isIOS() {
        return /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase());
    }

    /**
     * return if device is mobile by size
     * @returns boolean
     */
    isMobileDeviceBySize() {
        return this.isSm() || this.isXs();
    }
}

